import { checkProductionMode } from '@provider-portal/common/utils/environment';
import { combineReducers, Reducer, ReducersMapObject } from 'redux';
import { RouterState } from 'redux-first-history';
import { PersistConfig, persistReducer } from 'redux-persist';
import localStoragePersister from 'redux-persist/lib/storage'; // defaults to localStorage for web

import { CredentialsSessionState } from '@bolteu/redux-session';

import { promotionsPermissionReducer } from 'rdx/promotions/reducer';
import { authRequestStateReducer } from 'rdx/session/reducer';
import { targetingParametersReducer } from 'rdx/targetingParameters/reducer';

import { accountReducer, AccountState } from './account';
import { notificationsReducer } from './notifications';
import { passwordReducer } from './password';
import { sessionReducer } from './session';
import { GlobalAppState } from './state';
import { supportReducer, SupportState } from './support';
import { themeReducer } from './theme/reducer';

const isProductionMode = checkProductionMode();

const sessionPersistConfig: PersistConfig<CredentialsSessionState> = {
  key: 'session',
  blacklist: ['authRequestState', 'abortAuthError', 'authError'],
  storage: localStoragePersister,
  debug: !isProductionMode,
};

const accountPersistConfig: PersistConfig<AccountState> = {
  key: 'account-selected-provider',
  whitelist: ['selectedProvider'],
  storage: localStoragePersister,
  debug: !isProductionMode,
};

const supportPersistConfig: PersistConfig<SupportState> = {
  key: 'support-selected-case',
  whitelist: ['selectedCase'],
  storage: localStoragePersister,
  debug: !isProductionMode,
};

// let's try to keep these ordered alphabetically for easy reading
export const rootReducer = (routerReducer: Reducer<RouterState>) =>
  // Slice reducers accept narrower action types
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  combineReducers<ReducersMapObject<GlobalAppState, any>>({
    account: persistReducer(accountPersistConfig, accountReducer),
    authRequest: authRequestStateReducer,
    theme: themeReducer,
    targetingParameters: targetingParametersReducer,
    notifications: notificationsReducer,
    password: passwordReducer,
    promotionsPermissions: promotionsPermissionReducer,
    router: routerReducer,
    support: persistReducer(supportPersistConfig, supportReducer),
    session: persistReducer(sessionPersistConfig, sessionReducer),
  });

export const ACCOUNT_STATE_PERSIST_KEY = 'persist:account-selected-provider';
